import detail from "./im-detail"

export default {
  post(url, params, needToken, successEvent, completeEvent, errorEvent) {
    detail.executeHttp(url, params, "POST", needToken, successEvent, completeEvent, errorEvent)
  },
  get(url, params, needToken, successEvent, completeEvent, errorEvent) {
    detail.executeHttp(url, params, "GET", needToken, successEvent, completeEvent, errorEvent)
  },
  patch(url, params, needToken, successEvent, completeEvent, errorEvent) {
    detail.executeHttp(url, params, "PATCH", needToken, successEvent, completeEvent, errorEvent)
  },
  put(url, params, needToken, successEvent, completeEvent, errorEvent) {
    detail.executeHttp(url, params, "PUT", needToken, successEvent, completeEvent, errorEvent)
  },
  delete(url, params, needToken, successEvent, completeEvent, errorEvent) {
    detail.executeHttp(url, params, "DELETE", needToken, successEvent, completeEvent, errorEvent)
  },

  /**
   * 显示通知
   * @param title 标题
   * @param msg
   * @param type 类型
   * @param time 持续时间-1不消失
   */
  showNotify(title, msg, type, time) {
    detail.showNotify(title, msg, type, time);
  },
  login(url, params, successEvent, completeEvent, errorEvent) {
    detail.login(url, params, successEvent, completeEvent, errorEvent)
  },
  /**
   *
   * @param msg
   * @param option {
   *   icon: "'1'成功，'5'失败"
   * }
   */
  showMessage(msg, option) {
    detail.showMessage(msg, option)
  },
  showAlert(msg, icon, callBack) {
    detail.showAlert(msg, icon, callBack)
  },
  showConfirm(msg, callBack, cancelCallback) {
    detail.showConfirm(msg,{
      shadeClose: true,
      icon: 3
    }, callBack, cancelCallback)
  },
  ossUpload(path, file, option, successEvent, progressEvent, errorEvent, completeEvent) {
    detail.ossUpload(path, file, option, successEvent, progressEvent, errorEvent, completeEvent)
  },
  logout() {
    detail.logout();
  },
  getLocation(successEvent, errorEvent, userCache = true) {
    detail.getLocation(successEvent, errorEvent, userCache);
  },
  cleanLoginStatus() {
    detail.cleanLoginStatus();
  },
  //获取我的账号信息
  getAccountInfo(callback) {
    detail.getAccountInfo(callback)
  },
  //获取我的账号信息
  getInfo(callback) {
    detail.getInfo(callback)
  },
  isMine(currId, callback) {
    detail.getAccountInfo(({id}) => {
      callback(id === currId)
    });
  },
  goMySpace() {
    detail.goMySpace();
  },
  goSpace(id) {
    detail.goSpace(id);
  },
}




// WEBPACK FOOTER //
// ./src/js/im.js